<div class="widget-toolbar" [class.expanded]="expanded">
  <button class="expand-toggle" type="button" (click)="toggleExpand()"
          [attr.aria-label]="expanded ? 'Collapse tools' : 'Expand tools'">
    <svg class="icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path *ngIf="!expanded" d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" stroke-width="2" fill="none"/>
      <path *ngIf="expanded" d="M6 6l12 12M6 18L18 6" stroke="currentColor" stroke-width="2" fill="none"/>
    </svg>
  </button>

  <div class="widgets" *ngIf="expanded">
    <!-- Heatmap toggle — when active, render heatmap instead of default pins + zoom-driven cluster -->
    <button type="button" class="icon-btn"
            [class.active]="state.renderMode === 'heatmap'"
            (click)="onHeatmapToggle()"
            title="Heatmap"
            [attr.aria-label]="state.renderMode === 'heatmap' ? 'Disable heatmap' : 'Enable heatmap'">
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
        <path d="M12 3s-5 6-5 10a5 5 0 0 0 10 0c0-4-5-10-5-10Z" fill="currentColor"/>
      </svg>
    </button>

    <div class="widget-divider"></div>

    <!-- Spatial select -->
    <button type="button" class="icon-btn"
            [class.active]="state.spatialSelectActive"
            (click)="onSpatialSelectClick()"
            title="Draw polygon to select bid items"
            attr.aria-label="Draw polygon to select bid items">
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M4 4l16 4-6 5 5 7-10-3-5-13z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>
    </button>
  </div>
</div>

